import { render, staticRenderFns } from "./FeedPosts.vue?vue&type=template&id=49d913f0&scoped=true&lang=pug&"
import script from "./FeedPosts.vue?vue&type=script&lang=js&"
export * from "./FeedPosts.vue?vue&type=script&lang=js&"
import style0 from "./FeedPosts.vue?vue&type=style&index=0&id=49d913f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d913f0",
  null
  
)

export default component.exports